class Gallery {

    constructor(el) {
        this.el = el
        this.init()
    }

    init() {
        this.gallery = this.el.querySelector("[data-product-gallery]")
        this.thumbnailsWrapper = this.el.querySelector("[data-product-gallery-thumbnails]")
    
        if (!this.gallery || !this.thumbnailsWrapper) return
    
        this.images = Array.from(this.gallery.querySelectorAll("img"))
        this.thumbnails = Array.from(this.thumbnailsWrapper.querySelectorAll("img"))
    
        if (!this.images.length || !this.thumbnails.length) return
    
        this.handleThumbnailClick = this.handleThumbnailClick.bind(this)
        this.handleThumbnailKeydown = this.handleThumbnailKeydown.bind(this)
    
        this.currentIndex = this.images.findIndex((image) => !image.classList.contains("hidden"))
        if (this.currentIndex === -1) {
          this.currentIndex = 0
        }

        this.images.forEach((image, index) => {
            image.addEventListener("click", () => {
                const event = new CustomEvent("clickSliderThumbnail", {
                  detail: { index },
                })
                document.dispatchEvent(event)
              })
            })
    
        this.showImage(this.currentIndex)
        this.enhanceThumbnails()
      }
    
      enhanceThumbnails() {
        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.setAttribute("data-gallery-index", index)
          thumbnail.setAttribute("role", "button")
          thumbnail.setAttribute("tabindex", "0")
          thumbnail.setAttribute("aria-current", index === this.currentIndex ? "true" : "false")
    
          thumbnail.addEventListener("click", this.handleThumbnailClick)
          thumbnail.addEventListener("keydown", this.handleThumbnailKeydown)
        })
      }
    
      handleThumbnailClick(event) {
        event.preventDefault()
        const index = parseInt(event.currentTarget.getAttribute("data-gallery-index"), 10)
        if (Number.isNaN(index) || index === this.currentIndex) return
    
        this.showImage(index)
      }
    
      handleThumbnailKeydown(event) {
        if (event.key !== "Enter" && event.key !== " ") return
        event.preventDefault()
    
        const index = parseInt(event.currentTarget.getAttribute("data-gallery-index"), 10)
        if (Number.isNaN(index)) return
    
        this.showImage(index)
      }
    
      showImage(index) {
        this.images.forEach((image, imageIndex) => {
          image.classList.toggle("hidden", imageIndex !== index)
        })
    
        this.thumbnails.forEach((thumbnail, thumbIndex) => {
          thumbnail.classList.toggle("is-active", thumbIndex === index)
          thumbnail.setAttribute("aria-current", thumbIndex === index ? "true" : "false")
        })
    
        this.currentIndex = index
      }
    
      destroy() {
        if (!this.thumbnails) return
    
        this.thumbnails.forEach((thumbnail) => {
          thumbnail.removeEventListener("click", this.handleThumbnailClick)
          thumbnail.removeEventListener("keydown", this.handleThumbnailKeydown)
          thumbnail.removeAttribute("data-gallery-index")
          thumbnail.removeAttribute("role")
          thumbnail.removeAttribute("tabindex")
          thumbnail.removeAttribute("aria-current")
        })
      }

}

export default Gallery